import type { MaxWriteFn } from "@jackedlogs/ui";

import { apiFetch } from "./api";

// The web half of the MAX-write seam. Web has no queue, so this never
// answers `queued` — same asymmetry, same reason, as ./durableWrite.
export const writeMax: MaxWriteFn = async (op) => {
  const path = `/api/me/maxes/${encodeURIComponent(op.exerciseId)}`;
  try {
    if (op.kind === "set") {
      await apiFetch(path, {
        method: "PUT",
        body: { valueKg: op.valueKg, source: op.source },
      });
    } else {
      await apiFetch(path, { method: "DELETE" });
    }
    return { outcome: "sent" };
  } catch (error) {
    return { outcome: "rejected", error };
  }
};
